"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PartyConnector_1 = __importDefault(require("./utils/PartyConnector"));
var PolicyConnector_1 = __importDefault(require("./utils/PolicyConnector"));
var AttachmentConnector_1 = __importDefault(require("./utils/AttachmentConnector"));
var SalesProductConnector_1 = __importDefault(require("./utils/SalesProductConnector"));
var SalesPoliciesConnector_1 = __importDefault(require("./utils/SalesPoliciesConnector"));
var UIConfigurationConnector_1 = __importDefault(require("./utils/UIConfigurationConnector"));
var fetchRequest_1 = require("./utils/fetchRequest");
var UserConnector_1 = __importDefault(require("./utils/UserConnector"));
/**
 * API Connector for Corporate Self Service
 */
var CorporateApiConnector = /** @class */ (function () {
    /**
     * Instantiate an CorporateApiConnector
     * Provide a key to look up access token
     * @param key key for the local storage item where access token is stored
     * @param baseUrl base url where connected API is running
     */
    function CorporateApiConnector(key, baseUrl) {
        fetchRequest_1.setAccessTokenKey(key);
        this.setLanguage('en-US');
        this.baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + "/";
        this.party = new PartyConnector_1.default(this.baseUrl);
        this.attachment = new AttachmentConnector_1.default(this.baseUrl);
        this.policy = new PolicyConnector_1.default(this.baseUrl);
        this.salesProduct = new SalesProductConnector_1.default(this.baseUrl);
        this.uiConfiguration = new UIConfigurationConnector_1.default(this.baseUrl);
        this.user = new UserConnector_1.default(this.baseUrl);
        this.salesPolicies = new SalesPoliciesConnector_1.default(this.baseUrl);
    }
    /**
     * Method provides setting of language header on the API level
     * Default value will fallback to en
     * @param language language for setting language header
     */
    CorporateApiConnector.prototype.setLanguage = function (language) {
        fetchRequest_1.setLanguageHeader(language);
    };
    return CorporateApiConnector;
}());
exports.default = CorporateApiConnector;
